import { useEffect } from 'react';
import { useSubNav } from '../contexts/SubNavContext';
import './People.css';

export default function People() {
    const { setSubNav } = useSubNav();

    useEffect(() => {
        setSubNav([
            { 
                href: '#mark1', 
                label: '조직도', 
                active: true,
                onClick: (e) => {
                    e.preventDefault();
                    const el = document.getElementById('mark1')
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }
        ]);

        return () => setSubNav(null);
    }, [setSubNav]);

    return (
        <>
            <div className="container">
                <div className="cont_visual people">
                    <h2>생각을 나누는 기업문화</h2>
                    <p>
                        서로의 의견을 존중하고 생각을 나누는 기업 문화를 만들어 나갑니다. <br />
                        IT 관련 10~20년 이상의 실무 경험을 보유한 최고의 전문가들이 고객의 시장 경쟁에서 항상 한 걸음 앞서 나갈 수 있도록 지원해 드리겠습니다.
                    </p>
                </div>
                <div className="cont wrap_cont">
                    <div className="cont_p" id="mark1">
                        <h3>조직도</h3>
                        <div>
                            <ul className="org-tree">
                                <li>
                                    <p className="top-color">CEO</p>
                                    <ul id="unitMngsup">
                                        <li className="mng-group01">
                                            <p className="mid-color">기업문화추진실</p>
                                            <ul className="depth02"></ul>
                                        </li>
                                        <li className="mng-group02">
                                            <p className="mid-color">경영관리본부</p>
                                            <ul className="depth02">
                                                <li>경영관리 Unit</li>
                                                <li>CDP운영 Unit</li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <ul id="unitEntbus">
                                        <li className="ent-group01">
                                            <p className="btm-color">지능형 SW 연구소</p>
                                            <ul className="depth02">
                                                <li>AI 에이전트기획 Unit</li>
                                                <li>혁신기술 소싱 Unit</li>
                                                <li>AI 기반 SW 개발 Unit</li>
                                            </ul>
                                        </li>
                                        <li className="ent-group02">
                                            <p className="btm-color">AX사업본부</p>
                                            <ul className="depth02 line02">
                                                <li>AX 사업개발 Unit</li>
                                                <li>제조 AX사업 Unit</li>
                                                <li>유통 AX사업 Unit</li>
                                            </ul>
                                        </li>
                                        <li className="ent-group03">
                                            <p className="btm-color">기업사업본부</p>
                                            <ul className="depth02">
                                                <li>TI사업 Unit</li>
                                                <li>TS사업 Unit</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
